import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import ClientsDropdown from "./ClientsDropdown";
import AboutUsDropdown from "./AboutUsDropdown";
import ServicesDropdown from "./ServicesDropdown";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const getNavLinkClass = (path) => {
    if (path === "/" && location.pathname === "/") {
      return "navbar-link active-link";
    }
    if (path !== "/" && location.pathname.startsWith(path)) {
      return "navbar-link active-link";
    }
    return "navbar-link";
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToPageTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    scrollToPageTop();
  };

  return (
    <div className={`navbar-container ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-left-section">
        <Link to="/" className="navbar-logo-link" onClick={handleLinkClick}>
          <img
            src="/logo.png"
            alt="Logo"
            className="navbar-logo-image"
            title="Laxmi Hospitality Services logo"
          />
          <span className="navbar-logo-text">Laxmi Hospitality Services</span>
        </Link>
      </div>

      <div className={`navbar-links-section ${menuOpen ? "active" : ""}`}>
        <Link to="/" className={getNavLinkClass("/")} onClick={handleLinkClick}>
          Home
        </Link>

        {/* Wrap "About Us" in a dropdown parent div */}
        <div className="navbar-dropdown-parent about-us-nav-item">
          <Link
            to="/aboutus"
            className={getNavLinkClass("/aboutus")}
            onClick={handleLinkClick}
          >
            About Us
          </Link>
          <AboutUsDropdown
            onLinkClick={handleLinkClick}
            scrolled={scrolled}
            menuOpen={menuOpen}
          />
        </div>

        {/* Add a separate link for "Our Journey" that will only appear on mobile */}
        <Link
          to="/journey"
          className={`${getNavLinkClass("/journey")} mobile-journey-link`}
          onClick={handleLinkClick}
        >
          Our Journey
        </Link>

       <div className="navbar-dropdown-parent services-nav-item">
          <Link
            to="/services"
            className={getNavLinkClass("/services")}
            onClick={handleLinkClick}
          >
            Our Services
          </Link>
          <ServicesDropdown
            onLinkClick={handleLinkClick}
            scrolled={scrolled}
            menuOpen={menuOpen}
          />
        </div>

        <Link
          to="/resources"
          className={`${getNavLinkClass("/resources")} mobile-resources-link`}
          onClick={handleLinkClick}
        >
          Resources
        </Link>

        <div className="navbar-dropdown-parent">
          <Link
            to="/clients"
            className={getNavLinkClass("/clients")}
            onClick={handleLinkClick}
          >
            Clients
          </Link>
          {/*  Pass menuOpen prop */}
          <ClientsDropdown
            onLinkClick={handleLinkClick}
            scrolled={scrolled}
            menuOpen={menuOpen}
          />
        </div>

        <Link
          to="/ourteam"
          className={getNavLinkClass("/ourteam")}
          onClick={handleLinkClick}
        >
          Our Team
        </Link>
        <Link
          to="/contactus"
          className={`${getNavLinkClass("/contactus")} mobile-contact`}
          onClick={handleLinkClick}
        >
          Contact Us
        </Link>
      </div>

      <div className="navbar-right-section">
        <Link
          to="/contactus"
          className="navbar-contact-link desktop-contact"
          onClick={handleLinkClick}
        >
          Contact Us
        </Link>
        <div className="navbar-hamburger" onClick={toggleMenu}>
          <span className="navbar-hamburger-bar"></span>
          <span className="navbar-hamburger-bar"></span>
          <span className="navbar-hamburger-bar"></span>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
